import useTranslation from 'hooks/useTranslation'
import { selectLightTheme } from 'appSlice'
import { useReduxSelector } from 'store'
import React from 'react'

const Legend: React.FC = () => {
  const lightTheme = useReduxSelector(selectLightTheme)
  const { t } = useTranslation('placeMap')

  return (
    <div className='placeMap__playground__legend'>
      <h2>{t('legend')}:</h2>
      <div
        className='placeMap__playground__legend__item'
        style={{
          backgroundColor: 'rgba(235, 0, 61, 0.25)',
          borderColor: 'rgba(235, 0, 61, 1)',
          color: 'rgba(235, 0, 61, 1)'
        }}>
        {t('selected')}
      </div>
      <div
        className='placeMap__playground__legend__item'
        style={{
          backgroundColor: 'rgba(70, 40, 149, 0.1)',
          borderColor: 'rgba(70, 40, 149, 1)',
          color: 'rgba(70, 40, 149, 1)'
        }}>
        {t('user')}
      </div>
      <div
        className='placeMap__playground__legend__item'
        style={lightTheme ? {
          backgroundColor: 'rgba(152, 152, 152, 0.1)',
          borderColor: 'rgba(122, 122, 122, 1)',
          color: 'rgba(122, 122, 122, 1)'
        } : {
          backgroundColor: 'rgba(216, 216, 216, 0.1)',
          borderColor: 'rgba(216, 216, 216, 1)',
          color: 'rgba(216, 216, 216, 1)'
        }}>
        {t('available')}
      </div>
      <div
        className='placeMap__playground__legend__item'
        style={lightTheme ? {
          backgroundColor: 'rgba(216, 216, 216, 0.1)',
          borderColor: 'rgba(216, 216, 216, 1)',
          color: 'rgba(216, 216, 216, 1)'
        } : {
          backgroundColor: 'rgba(152, 152, 152, 0.1)',
          borderColor: 'rgba(122, 122, 122, 1)',
          color: 'rgba(122, 122, 122, 1)'
        }}>
        {t('unavailable')}
      </div>
    </div>
  )
}

export default Legend